import React from 'react'
import icons from '../icons-config/icons'
import {getLayout} from '../../layout/core'

type Props = {
  className?: string
  iconType?: 'duotone' | 'solid' | 'outline'
  iconName: string
}

const KTIcon: React.FC<Props> = ({className = '', iconType, iconName}) => {
  if (!iconType) {
    iconType = getLayout().main?.iconType
  }

  let iconClass = '';
  
  switch (iconName) {
    case 'organization':
      iconClass = 'fa fa-building-columns fs-2';
      break;
    case 'employee':
      iconClass = 'fa fa-users fs-2';
      break;
    case 'fa fa-clipboard-user':
      iconClass = 'fa fa-clipboard-user fs-4';
      break;
    case 'fa fa-building-columns':
      iconClass = 'fa fa-building-columns';
      break;
    case 'fa fa-city':
      iconClass = 'fa fa-city';
      break;
    case 'fa fa-earth-americas':
      iconClass = 'fa fa-earth-americas';
      break;
    case 'fa fa-building-columns':
      iconClass = 'fa fa-building-columns';
      break;
    case 'fa fa-address-card':
      iconClass = 'fa fa-address-card';
      break;
    case 'fa fa-right-from-bracket':
      iconClass = 'fa fa-right-from-bracket';
      break;
    case 'fa fa-person-circle-question':
      iconClass = 'fa fa-person-circle-question';
      break;
    case 'fa-brands fa-cc-visa':
      iconClass = 'fa-brands fa-cc-visa fs-4';
      break;
    case 'fa fa-layer-group':
      iconClass = 'fa fa-layer-group';
      break;
    case 'fa fa-business-time':
      iconClass = 'fa fa-business-time';
      break;
    case 'fa fa-wallet':
      iconClass = 'fa fa-wallet';
      break;
    case 'fa fa-file':
      iconClass = 'fa fa-file fs-4';
      break;
    case 'fa fa-link':
      iconClass = 'fa fa-link';
      break;
    case 'fa fa-house-person-leave':
      iconClass = 'fa fa-house-person-leave';
      break;
    case 'fa fa-language':
      iconClass = 'fa fa-language';
      break;
    case 'fa fa-briefcase':
      iconClass = 'fa fa-briefcase fs-5';
      break;
    case 'fa fa-list-alt':
      iconClass = 'fa fa-list-alt';
      break;
    case 'fa fa-industry':
      iconClass = 'fa fa-industry';
      break;
    case 'fa fa-calendar':
      iconClass = 'fa fa-calendar';
      break;
    case 'fa fa-passport':
      iconClass = 'fa fa-passport fs-4';
      break;
    case 'fa fa-ranking-star':
      iconClass = 'fa fa-ranking-star fs-4';
      break;
    case 'fa fa-id-card':
      iconClass = 'fa fa-id-card';
      break;
    case 'fa fa-list':
      iconClass = 'fa fa-list';
      break;
    case 'fa fa-user-plus':
      iconClass = 'fa fa-user-plus';
      break;
    case 'fa fa-user-clock':
      iconClass = 'fa fa-user-clock';
      break;
    case 'fa fa-address-book':
      iconClass = 'fa fa-address-book';
      break;
    case 'fa fa-person-walking-arrow-right':
      iconClass = 'fa fa-person-walking-arrow-right';
      break;
    case 'fa fa-list-check':
      iconClass = 'fa fa-list-check';
      break;
      case 'fas fa-user-shield':
      iconClass = 'fas fa-user-shield';
      break;
    // Add more cases as needed
    default:
      iconClass = `ki-${iconType} ki-${iconName}${className ? ' ' + className : ''}`;
  }

  return (
    <i className={iconClass}>
      {iconType === 'duotone' &&
        [...Array(icons[iconName])].map((e, i) => {
          return (
            <span
              key={`${iconType}-${iconName}-${className}-path-${i + 1}`}
              className={`path${i + 1}`}
            ></span>
          )
        })}
    </i>
  )
}

export {KTIcon}
